import AjaxBuilder from "../../../../Common/AjaxBuilder";
import { Util } from "../../../../Common/Util";

export class ItemsWrapper {
    constructor({ page, handler, getRoutes }) {
        this.$page = page;
        this._getRoutes = getRoutes;

        this.$resultWrapper = $(this.$page).find('.avia_results_list');
        this._handler = handler;

        this._formatter = new Intl.NumberFormat(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

        this._init();
    }

    _init() {
        $(document).on('click', '.details_btn', function () {
            $(this).toggleClass('_open').closest('.avia_results_item').find('.avia_results_item_details').slideToggle();
        });

        $(document).on('click', '.stops_title', function () {
            $(this).closest('.route').toggleClass('_open_stops');
            $(this).closest('.stops').toggleClass('_open').find('.stops_list').slideToggle();
        });

        $(this.$resultWrapper).on('click', 'button.save-route__btn', this._handler);

        $(document).on('click', '.select_baggage_title', this._showBaggageWindow.bind(this));
        $(document).on('click', '.select_baggage_list_item', this._selectBaggageItem.bind(this));

    }

    _showBaggageWindow(event) {
        const selectedItem = $(event.currentTarget);
        selectedItem.next('.select_baggage_list').addClass('_open');

        if (selectedItem.closest('.select_baggage').attr('data-baggage-loaded') === '1') return;

        const routeId = selectedItem.closest('.avia_results_item').data('routeid');
        const flight = this._getRoutes().find(route => route['id'] === routeId);

        new AjaxBuilder({
            route: `${Util.getLocalization()}avia/api/baggage-data/`,
            data: {
                session_id: flight.session_id,
                flight_id: flight.id,
                apiName: 'Tickets',
            },
            token: Util.token(),
        }, 'GET').execute({
            success: ({ response }) => {
                selectedItem.closest('.select_baggage').attr('data-baggage-loaded', '1');
                selectedItem.next('.select_baggage_list').html(response.view);
            },
        });
    }

    _selectBaggageItem(event) {
        const selectedItem = $(event.currentTarget);

        let baggage = selectedItem.data('baggage');
        $('.select_baggage_list_item._active').removeClass('_active');
        selectedItem.closest('.select_baggage').find('.select_baggage_title').removeClass('_yes _no').addClass((baggage == 0) ? '_no' : '_yes').find('div').text(selectedItem.find('._left div').text());
        selectedItem.closest('.select_baggage').find('input').val(baggage);
        selectedItem.addClass('_active');
        selectedItem.closest('.select_baggage_list').removeClass('_open');

        const price = selectedItem.data('price');
        const routeId = selectedItem.closest('.avia_results_item').data('routeid');
        const flight = this._getRoutes().find(route => route['id'] === routeId);

        selectedItem.closest('.avia_results_item').find('.price span').html(this._formatter.format(flight.price + price));
    }

    drawRoutes(view) {
        this.$resultWrapper.html(view);
    }

    removeRoutes() {
        this.$resultWrapper.html('');
    }

    appendRoute(route) {
        this.$resultWrapper.append(route);
    }

    hide() {
        $(this.$resultWrapper).hide();
    }

    show() {
        $(this.$resultWrapper).show();
    }
}